import React from "react"
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { m } from "framer-motion"
import { Ripple } from "./ripple"
export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

const Card = React.forwardRef(({ className, isPressable, isHoverable, isGlass, children, ...props }, ref) => {
    const Comp = isPressable || isHoverable ? m.div : "div"
    
    const motionProps = isPressable || isHoverable ? {
        whileHover: isHoverable ? { y: -2 } : undefined,
        whileTap: isPressable ? { scale: 0.98 } : undefined,
    } : {}

    return (
        <Comp
            ref={ref}
            className={cn(
                "rounded-xl border shadow-sm relative overflow-hidden transition-all",
                isGlass 
                    ? "glass" 
                    : "bg-card text-card-foreground dark:border-gray-800",
                isPressable && "cursor-pointer select-none",
                className
            )}
            {...motionProps}
            {...props}
        >
            {children}
            {isPressable && <Ripple />}
        </Comp>
    )
})
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn("flex flex-col space-y-1.5 p-6", className)}
        {...props}
    />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
    <h3
        ref={ref}
        className={cn("text-2xl font-semibold leading-none tracking-tight text-foreground", className)}
        {...props}
    />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
    <p
        ref={ref}
        className={cn("text-sm text-muted-foreground", className)}
        {...props}
    />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
    <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn("flex items-center p-6 pt-0", className)}
        {...props}
    />
))
CardFooter.displayName = "CardFooter"

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
